type Organization = {
  name: string;
  type: string;
  vat: string;
  billingAddress: {
    street: string;
    additionalAddress: string;
    zipCode: string;
    city: string;
    state: string;
    country: string;
  };
  principalAddress: {
    street: string;
    additionalAddress: string;
    zipCode: string;
    city: string;
    state: string;
    country: string;
  };
};

const organization: Organization = {
  name: "",
  type: "",
  vat: "",
  billingAddress: {
    additionalAddress: "",
    city: "",
    country: "",
    state: "",
    street: "",
    zipCode: "",
  },
  principalAddress: {
    additionalAddress: "",
    city: "",
    country: "",
    state: "",
    street: "",
    zipCode: "",
  },
};

export type { Organization };

export { organization };
